/**
 * Holds the current player JWT in memory only (never localStorage — nothing
 * in this client persists tokens to browser storage; a fresh page load
 * always re-authenticates, matching StateManager's boot -> unauthenticated
 * default path).
 */
export class AuthTokenStore {
  private token: string | null = null;

  set(token: string | null): void {
    this.token = token;
  }

  get(): string | null {
    return this.token;
  }

  clear(): void {
    this.token = null;
  }
}
